import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HomeBelievePage.css';

// Replace with your actual flyer image import
import believeFlyer from '../Assets/storyfest/believe.png'; 

const HomeBelievePage = () => {
  const navigate = useNavigate();

  return (
    <section className="homebelieve-section">
      
      {/* Background Texture/Pattern */}
      <div className="homebelieve-bg-pattern"></div>
      
      {/* Decorative Glows */}
      <div className="homebelieve-glow homebelieve-glow-gold"></div>
      <div className="homebelieve-glow homebelieve-glow-warm"></div>

      {/* Main Content Container */}
      <div className="homebelieve-container">
        
        <div className="homebelieve-grid">
          
          {/* LEFT SIDE: Editorial Text & CTA */}
          <div className="homebelieve-text-content">
            
            <div className="homebelieve-badge">
              <span className="homebelieve-pulse-dot"></span>
              A Christmas Musical
            </div>

            <h2 className="homebelieve-title">
              Believe in<br />
              <span className="homebelieve-text-gold">something</span><br />
              extraordinary.
            </h2>
            
            <p className="homebelieve-description">
              This Christmas, experience an original theatrical journey filled 
              with soul-stirring music, captivating storytelling, and the 
              wonder and magic of believing.
            </p>

            {/* Main CTA Button - Navigates to Days Selection */}
            <button 
              onClick={() => navigate('/believe-days')} 
              className="homebelieve-btn homebelieve-btn-gold"
            >
              Get Believe Tickets
              <span className="homebelieve-arrow">↗</span>
            </button>

            {/* Link to full page if they exist */}
            <button 
              onClick={() => navigate('/believe')} 
              className="homebelieve-learn-more"
            >
              Learn more about the production →
            </button>

          </div>

          {/* RIGHT SIDE: Flyer Display */}
          <div className="homebelieve-flyer-content">
            <div className="homebelieve-flyer-wrapper">
              <img 
                src={believeFlyer} 
                alt="Believe Christmas Musical Flyer" 
                className="homebelieve-flyer-img" 
              />
            </div>
            
            {/* Secondary CTA below flyer - Navigates to Days Selection */}
            <button 
              onClick={() => navigate('/believe-days')} 
              className="homebelieve-btn homebelieve-btn-outline homebelieve-btn-below-flyer"
            >
              Get Tickets Now
              <span className="homebelieve-arrow">→</span>
            </button>
          </div>

        </div>

      </div>
    </section>
  );
};

export default HomeBelievePage;